import { apiClient } from '../api-client';
import { getLocale, getProfileId } from 'lib/store';
import {
  AccountStatus,
  DashboardDetail,
  OnboardingStep,
  TermAndCondition,
} from './type';

export const getAccountStatus = async (): Promise<AccountStatus> => {
  return await apiClient.get(`/account_status?os=web&locale=${getLocale()}`);
};

export const getOnboarding = async () => {
  return await apiClient.get<OnboardingStep[]>(
    `/onboarding?os=web&locale=${getLocale()}`
  );
};

export const updateOnboardingStep = async (data: { milestone: string }) => {
  return await apiClient.post(
    `/onboarding?os=web&locale=${getLocale()}&profile_id=${getProfileId()}`,
    data
  );
};

export const getOnboardingSteps = async () => {
  return await apiClient.get<OnboardingStep[]>(
    `/onboarding-steps?os=web&locale=${getLocale()}`
  );
};

export const getTnC = async () => {
  return await apiClient.get<TermAndCondition[]>(
    `/tnc?os=web&locale=${getLocale()}&profile_id=${getProfileId()}`
  );
};

export const getDashboardDetails = async (profile_id: string) => {
  return (await apiClient.get('/user_dashboard_flag', {
    params: {
      os: 'web',
      locale: getLocale(),
      profile_id,
    },
  })) as DashboardDetail;
};
